module.exports = __WEBPACK_EXTERNAL_MODULE_73__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","platformBrowserAnimations"],"commonjs":"@angular/platform-browser/animations","commonjs2":"@angular/platform-browser/animations","amd":"@angular/platform-browser/animations"}
// module id = 73
// module chunks = 0 1